<aside class="rail">
  <div class="card pad" style="padding:18px 18px 16px">
    <h3>Coverage check</h3>

    <div class="tbl-scroll"><table class="mx" aria-label="Approved document frequency" aria-live="polite">
      <thead><tr><th></th><th>As-Is · ECC</th><th>To-Be · S/4</th></tr></thead>
      <tbody>
        <tr *ngFor="let t of types">
          <td class="rh">
            <span [style.background]="docTypes[t].color" style="display:inline-block;width:8px;height:8px;border-radius:2px;margin-right:6px"></span>{{ docTypes[t].short }}
            <small class="unknown-approved" *ngIf="df.approvedCount(t, 'unknown') as count">{{ count }} approved · landscape unknown</small>
          </td>
          <td *ngFor="let land of landscapes">
            <div class="cell na" *ngIf="!df.isCellApplicable(t, land)">Not applicable</div>
            <div class="cell na" *ngIf="df.isCellApplicable(t, land) && !df.isCellInScope(land)">Out of scope</div>
            <div class="cell" *ngIf="df.isCellApplicable(t, land) && df.isCellInScope(land)" [attr.data-cell]="t + '|' + land"
              [class.has-approvals]="df.approvedCount(t, land) > 0" [style.--frequency-color]="docTypes[t].color"
              [attr.aria-label]="docTypes[t].short + ' ' + landLabel(land) + ': ' + df.approvedCount(t, land) + ' approved documents'">
              <div class="num">{{ df.approvedCount(t, land) }}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table></div>

  </div>

  <section class="card custom-documents">
    <div class="custom-header">
      <div>
        <h3>Add Additional Custom Documents/Business Scenarios</h3>
        <p>Users can upload or select additional business scenarios/documents.</p>
      </div>
      <button type="button" class="btn sm add-missing" (click)="reportAny()"><df-icon name="plus" [size]="14"></df-icon>Add</button>
    </div>
    <div class="custom-content">
      <ng-container *ngIf="df.missing.length; else noneMissing">
        <div class="custom-document" *ngFor="let m of df.missing; let i = index">
          <div class="custom-title">
            <b>{{ m.title || 'Untitled document' }}</b>
            <span class="custom-actions">
              <button type="button" class="link edit-missing" (click)="df.openMissing(null, i)">Edit</button>
              <button type="button" class="link remove-missing" (click)="df.removeMissing(i)">Remove</button>
            </span>
          </div>
          <dl class="kv">
            <dt>Type</dt><dd>{{ docTypes[m.type].short }} · {{ landLabel(m.land, true) }}</dd>
            <dt>Process</dt><dd>{{ m.l2 }}{{ m.l3 ? ' · ' + m.l3 : '' }}</dd>
            <ng-container *ngIf="m.attachment as attachment">
              <dt>Attachment</dt><dd>{{ attachment.name }} · Uploaded; not yet searchable. Use Edit to download.</dd>
            </ng-container>
            <ng-container *ngIf="m.loc"><dt>Where it lives</dt><dd>{{ m.loc }}</dd></ng-container>
            <ng-container *ngIf="m.owner"><dt>Owner</dt><dd>{{ m.owner }}</dd></ng-container>
            <ng-container *ngIf="m.date"><dt>Approx. date</dt><dd>{{ m.date }}</dd></ng-container>
            <ng-container *ngIf="m.marker"><dt>How to recognise it</dt><dd>{{ m.marker }}</dd></ng-container>
            <ng-container *ngIf="m.why"><dt>Why it matters</dt><dd>{{ m.why }}</dd></ng-container>
          </dl>
        </div>
      </ng-container>
      <ng-template #noneMissing>
        <div class="empty">No custom documents added.</div>
      </ng-template>
    </div>
  </section>
</aside>
